import Settings from './Settings.vue';
import MenuItem from './MenuItem.vue';

const routes = [
  {
    name: 'modules.manual_payment',
    component: Settings,
    path: '/modules/manual_payment',
  },
];

export default {
  menu_item: MenuItem,
  settings_component: Settings,
  routes,
};
